import { Link } from "react-router-dom";
import { BellRing, CalendarDays, ScanLine, ShieldCheck, Sparkles } from "lucide-react";

const FEATURES = [
  [ScanLine, "AI card scanning", "Snap or upload — details fill in automatically."],
  [CalendarDays, "Events & follow-ups", "Remember where you met and when to reconnect."],
  [BellRing, "Goals & reminders", "Daily networking goals that build a streak."],
];

function CardStack() {
  return (
    <div className="relative h-[210px] w-[340px]" aria-hidden>
      <div className="absolute left-10 top-6 w-[290px] h-[170px] rounded-[18px] bg-white/10 border border-white/20 rotate-[8deg]" />
      <div className="absolute left-0 top-0 w-[300px] h-[176px] rounded-[18px] bg-white text-[#0F172A] p-5 shadow-[0_30px_60px_-20px_rgba(0,0,0,.45)] -rotate-[4deg] transition-transform duration-500 hover:rotate-0">
        <div className="flex items-start justify-between">
          <div><p className="text-[16px] font-extrabold">Sai Krishna Salumuri</p><p className="text-[12px] text-[#64748B]">Founder · Kensworth</p></div>
          <img src="/logo.png" alt="" className="w-9 h-9 rounded-lg" />
        </div>
        <div className="mt-5 space-y-1.5 text-[11px] text-[#475569]"><p>+91 94904 00497</p><p>info@kensworth.in</p><p>Hyderabad, India</p></div>
        <span className="absolute right-4 bottom-4 inline-flex items-center gap-1 rounded-full bg-[#ECFDF5] text-[#047857] text-[10px] font-bold px-2 py-1"><Sparkles className="w-3 h-3" />Scanned</span>
        <div className="absolute inset-x-4 top-[46%] h-[2px] bg-[#0000EC]/70 shadow-[0_0_12px_2px_rgba(0,0,236,.5)] animate-pulse" />
      </div>
    </div>
  );
}

export default function AuthLayout({ children, wide, topRight }) {
  return (
    <div className="min-h-screen bg-white lg:grid lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
      <aside className="hidden lg:flex flex-col justify-between bg-[#0000EC] text-white p-12 relative overflow-hidden h-screen sticky top-0">
        <div className="absolute inset-0 opacity-[0.12] [background-image:radial-gradient(white_1px,transparent_1px)] [background-size:22px_22px]" />
        <div className="absolute -right-32 -top-32 w-[420px] h-[420px] rounded-full bg-white/10" />
        <div className="absolute -left-24 -bottom-24 w-80 h-80 rounded-full bg-[#4338CA]" />
        <Link to="/login" className="relative flex items-center gap-3"><img src="/logo.png" alt="TOTO" className="w-11 h-11 rounded-xl ring-2 ring-white/30" data-testid="auth-logo" /><span className="text-[26px] font-extrabold tracking-tight">TOTO</span></Link>
        <div className="relative">
          <p className="text-[44px] xl:text-5xl font-extrabold leading-[1.08]">Scan.<br />Stay Connected.</p>
          <p className="mt-4 text-[16px] text-white/80 max-w-sm">Turn every visiting card into a lasting connection. Every card matters.</p>
          <div className="mt-10"><CardStack /></div>
          <ul className="mt-10 space-y-4 max-w-sm">
            {FEATURES.map(([Icon, t, d]) => (
              <li key={t} className="flex gap-3">
                <span className="w-10 h-10 shrink-0 rounded-[12px] bg-white/15 flex items-center justify-center"><Icon className="w-5 h-5" /></span>
                <span><span className="block text-[15px] font-bold">{t}</span><span className="block text-[13px] text-white/70">{d}</span></span>
              </li>
            ))}
          </ul>
        </div>
        <p className="relative flex items-center gap-2 text-[12px] text-white/60"><ShieldCheck className="w-4 h-4" />Your contacts stay private to your account.</p>
      </aside>

      <div className="relative flex flex-col min-h-screen">
        <div className="lg:hidden relative bg-[#0000EC] text-white px-6 pt-10 pb-16 overflow-hidden">
          <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-white/10" />
          <div className="relative flex items-center gap-3"><img src="/logo.png" alt="TOTO" className="w-11 h-11 rounded-xl ring-2 ring-white/30" data-testid="login-logo" /><span className="text-[24px] font-extrabold">TOTO</span></div>
          <p className="relative mt-5 text-[26px] font-extrabold leading-tight">Scan. Stay Connected.</p>
          <p className="relative text-[14px] text-white/80">Every card matters.</p>
        </div>
        {topRight && <div className="hidden lg:flex justify-end px-10 pt-8 text-[14px] text-[#475569]">{topRight}</div>}
        <div className="relative flex-1 flex justify-center lg:items-center lg:px-10 -mt-8 lg:mt-0 pb-10">
          <div className={`w-full ${wide ? "max-w-[560px]" : "max-w-[420px]"} bg-white rounded-t-[28px] lg:rounded-none px-6 lg:px-0 pt-7 lg:pt-0 fade-up`}>{children}</div>
        </div>
      </div>
    </div>
  );
}
